module.exports = __webpack_public_path__ + "static/media/bubble_reecall_2020.8537663d.svg";